import { ChangeDetectionStrategy, Component, Input, OnInit, signal } from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'v2-turbine',
  templateUrl: './v2-turbine.component.html',
  styleUrls: ['./v2-turbine.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2TurbineComponent implements OnInit {
  @Input() speed = '';
  @Input() contrast = false;
  @Input() withPole = true;
  @Input() shadow = true;
  @Input() text = false;

  currLoadingNum = signal(0);
  reload = signal(false);

  ngOnInit() {
    if (this.text) {
      this.updateLoadingNum();
    }
  }

  updateLoadingNum() {
    setTimeout(() => {
      if (this.currLoadingNum() < 5) {
        this.reload.set(true);
        setTimeout(() => {
          this.currLoadingNum.update(num => num + 1);
          this.reload.set(false);
          this.updateLoadingNum();
        }, 350);
      }
    }, 4000);
  }
}
